/* eslint no-console:0 */

// app/javascript/packs/application.js


// Import necessary libraries
// Import Bootstrap's JavaScript
import { createPopper } from '@popperjs/core'; // Popper.js first
import 'bootstrap'; // Bootstrap JS includes everything we need (Bootstrap 5 no longer depends on jQuery)


// Import Alert
import Swal from 'sweetalert2';
window.Swal = Swal;

import '@lottiefiles/lottie-player';



// Make boostrap globally available
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;


// Make jQuery globally available
import $ from 'jquery';
import 'jquery-ui/ui/widgets/sortable'; // Import sortable module

global.$ = global.jQuery = $;

import formBuilder from 'formBuilder';
import Rails from "@rails/ujs";
Rails.start();

import { Application } from "stimulus";
import { definitionsFromContext } from "stimulus/webpack-helpers";

// Initialize Stimulus
const application = Application.start();

// Define Stimulus controllers
const context = require.context("controllers", true, /\.js$/);
application.load(definitionsFromContext(context));



import "select2/dist/css/select2.css";
import "select2-bootstrap-5-theme/dist/select2-bootstrap-5-theme.min.css";
import "select2";



document.addEventListener('DOMContentLoaded', () => {
  const colorInputs = document.querySelectorAll('.coloris');
  if (colorInputs.length > 0) {
    const htmlLang = document.documentElement.lang || 'en';
    const clearText = htmlLang.startsWith('tr') ? 'Temizle' : 'Clear';
    const closeText = htmlLang.startsWith('tr') ? 'Kapat' : 'Close';

    // Dinamik olarak hem CSS'i hem JS'i import et
    Promise.all([
      import("@melloware/coloris/dist/coloris.min.css"),
      import("@melloware/coloris")
    ]).then(([, ColorisModule]) => {
      const Coloris = ColorisModule.default;

      Coloris.init();
      Coloris({
        el: '.coloris',
        theme: 'polaroid',
        themeMode: 'auto',
        format: 'hex',
        clearButton: true,
        clearLabel: clearText,
        closeButton: true,
        closeLabel: closeText,
        alpha: true,
        swatches: [
          "#03a9f4", "#2ecc71", "#3498db", "#9b59b6", "#f1c40f",
          "#e67e22", "#e74c3c", "#34495e", "#ecf0f1", "#95a5a6",
          "#8e44ad", "#c0392b"
        ]
      });
    });
  }
});






const path = window.location.pathname;
import Highcharts from "highcharts";
window.Highcharts = Highcharts;




import "@nathanvda/cocoon";

// Import Bootstrap Colorpicker
//import 'bootstrap-colorpicker/dist/js/bootstrap-colorpicker.min.js';
//import 'bootstrap-colorpicker/dist/css/bootstrap-colorpicker.min.css';


import "trix"
import "@rails/actiontext"



import "summernote/dist/summernote-bs5.css";
import "summernote/dist/summernote-bs5.js";



import Papa from "papaparse";

// Opsiyonel: global olarak erişilebilir yapmak istersen
window.Papa = Papa;


import * as XLSX from 'xlsx';
window.XLSX = XLSX;



import stringSimilarity from 'string-similarity';
window.stringSimilarity = stringSimilarity;






//import moment from "moment";
//window.moment = moment; // Make it globally available

//replace moment with dayjs
import dayjs from 'dayjs';

window.dayjs = dayjs


import "daterangepicker";



// Import custom JavaScript after jQuery and Highcharts are globally available
import "../custom/custom";
import "../custom/table";
import "../custom/confirm_alert";
import "../custom/wizard";


// Patch to add getTipElement method for Bootstrap Popovers
if (typeof bootstrap.Popover.prototype.getTipElement === 'undefined') {
    bootstrap.Popover.prototype.getTipElement = function () {
      return this.tip || document.querySelector('.popover');
    };
}
